<!--
 * @FileDescription: 分销账单
 * @Author: xy（作者）
 * @Date: 2020-12-31（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container">
      <div class="page-container-height">
          <div class="order-top">
                <div class="order-top-left">
                    <a-month-picker placeholder="请选择" v-model="createtime" style="width:200px" @change="onChangedate" />
                    <a-input  class="market-input" v-model="keyword" placeholder="请输入用户手机号"  @pressEnter="onSearch()" />
                    <a-button class="button-search" @click.stop="onSearch()">筛选</a-button>
                    <a-button class="button-search1" @click.stop="onRest(1)">重置</a-button>        
                </div>
                <!-- <div class="order-top-right"><img src="@/assets/image/daochu (1)@2x.png" alt="">导出</div>        -->
          </div>
          <div class="line"></div>  
          <div class="market-tab">
                <div class="market-tab-item" :class="tabindex == 0 ? 'market-tab-item-active':''" @click="changTab(0)">
                    <img src="@/assets/image/adjustment-img4.png" alt="" v-if="tabindex == 0">
                    <img src="@/assets/image/adjustment-img1.png" alt="" v-else>
                    全部
                </div>
                <div class="market-tab-line"></div>
                 <div class="market-tab-item" :class="tabindex == 1? 'market-tab-item-active':''" @click="changTab(1)">
                    <img src="@/assets/image/daichuzhang.png" alt="" v-if="tabindex == 1">
                    <img src="@/assets/image/daichuzhang1.png" alt="" v-else>
                    待确认
                </div>
                <div class="market-tab-line"></div>
                 <div class="market-tab-item" :class="tabindex == 2 ? 'market-tab-item-active':''" @click="changTab(2)">
                    <img src="@/assets/image/daiqueren.png" alt="" v-if="tabindex == 2">
                    <img src="@/assets/image/daiqueren1.png" alt="" v-else>
                    待出账
                </div>
                <div class="market-tab-line"></div>
                 <div class="market-tab-item" :class="tabindex == 3 ? 'market-tab-item-active':''" @click="changTab(3)">
                    <img src="@/assets/image/yiwacheng-01.png" alt="" v-if="tabindex == 3">
                    <img src="@/assets/image/yiwanc-02.png" alt="" v-else>
                    已出账
                </div>
                <div class="market-tab-line"></div>
                 <div class="market-tab-item" :class="tabindex == 4 ? 'market-tab-item-active':''" @click="changTab(4)">
                    <img src="@/assets/image/yiguanbi-01.png" alt="" v-if="tabindex == 4">
                    <img src="@/assets/image/yiguanbi-02.png" alt="" v-else>
                    已关闭
                </div>
            </div>
             <a-table :columns="columns"
                     :dataSource="dataSource"
                     :pagination="false"
                     :scroll="{x:800,y: 'calc(100vh - 310px)'}"
                     class="table-log-height"
                     bordered
                     rowKey="key">
                <template slot="state" slot-scope="text, record, index">
                    <span class="state-title state-titile1" v-if="record.state == 2"><span class="state-cire-order"></span>待出账</span>
                    <span class="state-title state-titile2" v-if="record.state == 1"><span class="state-cire-order"></span>待确认</span>
                    <span class="state-title state-titile1" v-if="record.state == 3"><span class="state-cire-order"></span>已出账</span>
                    <span class="state-title" v-if="record.state == 4"><span class="state-cire-order"></span>已关闭<span v-if="record.closeReason">（{{record.closeReason}}）</span></span>
                </template>
                <template slot="operation" slot-scope="text, record, index">
                    <span class="operation-title" @click="btnDetails(record, 1)">查看详情</span>
                    <span class="operation-title" style="margin-left:20px;" @click="btnDetails(record, 2)">关联销售单</span>
                </template>
            </a-table>
             <div class="pagination-footer-box">
                <a-pagination :total="pagination.total" :page-size="pagination.pageSize" :default-current="pagination.current"
                    :show-total="pagination.showTotal" @showSizeChange="onShowSizeChange" @change="handleTableChange"
                    show-size-changer show-quick-jumper />
            </div>
      </div>
  </div>
</template>
<script>
import {getPageAccount} from "@/utils/api";
import {mixins} from "@/mixins/mixins";
import {method} from '../method/method'
export default {
    name:'marketorder',
    mixins:[mixins,method],
    data(){
        return{
            keyword:'',
            tabindex:0,
            datatime:null,
            createtime:null,
            columns: [
                {
                    title: '',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 70,
                    align: 'center',
                    customRender(t, r, index) {
                        return parseInt(index) + 1
                    }
                },
                {
                    title: '单据编号',
                    key: 'orderId',
                    dataIndex: 'orderId',
                    width:180,
                     ellipsis: true,
                },
                {
                    title: '单据日期',
                    key: 'createTime',
                    dataIndex: 'createTime',
                    width:150,
                    ellipsis: true,
                },
                {
                    title: '收货人',
                    dataIndex: 'orderOwnerName',
                    key: 'orderOwnerName',
                    ellipsis: true,
                },
                {
                    title: '出账日',
                    dataIndex: 'settleTime',
                     width:150,
                      ellipsis: true,
                    key: 'settleTime',
                },
                {
                   title: '订单金额',
                    key: 'orderAmount',
                    dataIndex: 'orderAmount',
                    align: 'right',
                    ellipsis: true,
                },
                {
                    title: '邀请奖金',
                    key: 'inviteCommission',
                    dataIndex: 'inviteCommission',
                    align: 'right',
                    ellipsis: true,
                },
                {
                    title: '自购奖金',
                    key: 'selfBuyCommission',
                    align: 'right',
                    dataIndex:'selfBuyCommission',
                    ellipsis: true,
                },
                {
                    title: '层级奖金',
                    key: 'levelCommission',
                    align: 'right',
                    dataIndex:'levelCommission',
                    ellipsis: true,
                },
                 {
                    title: '公共奖金',
                    key: 'publicBonus',
                    align: 'right',
                    dataIndex:'publicBonus',
                    ellipsis: true,
                },
                {
                    title: '平台佣金',
                    key: 'platformCommission',
                    align: 'right',
                    dataIndex:'platformCommission',
                    ellipsis: true,
                },
                {
                    title: '状态',
                    key: 'state',
                    dataIndex:'state', 
                    scopedSlots: { customRender: 'state' },
                },
                {
                    title: '操作',
                    width:160,
                    scopedSlots: { customRender: 'operation' },
                },
            ],
            dataSource: [],
        }
    },
    watch: {

    },
    mounted () {
        this.getmessagedata()
    },
    created () {

    },
    components: {


    },
    methods: {
        /**
        * @description: 此为方法注释（方法描述）
        */
        getmessagedata(){
            this.getmessageobj('/mall-account/web/bill/pageListBill',{   
                    companyStoreId:this.$store.state.shopId,
                    current:this.pagination.current,
                    size:this.pagination.pageSize,
                    billState:this.tabindex,
                    receiveMobile:this.keyword,
                    billCreateTime:this.datatime
                },{})
        },
        /**
        * @description: 筛选
        */
        onSearch(){
            this.getmessagedata()
        },
         /**
        * @description: 重置
        */
        onRest(){
            this.keyword = ''
            this.datatime = null
            this.createtime = null
            this.pagination.current = 1
            this.getmessagedata()
        },
        onChangedate(date, dateString){
            this.datatime = dateString + '-01'
        },
        changTab(index){
            this.tabindex = index
            this.pagination.current = 1
            this.getmessagedata()
        },
        btnDetails(record,index){
            if(index == 1){
                this.$router.push({
                    path:'/marketing/marketmanage/marketorderDetail',
                    query:{
                        id:record.id,
                        state:record.state,
                        receiverMobile:record.receiverMobile,
                        code:record.code,
                        createTime:record.createTime,
                        closeReason:record.closeReason,
                        orderId:record.orderId
                    }
                })
            }else{
                var type = ''
                if(record.state == 1){
                    type = 1
                }else if(record.state == 2){
                    type = 2
                }else if(record.state == 3){
                    type = 4
                }else if(record.state == 4){
                    type = 7
                }
                this.$router.push('/cloudstore/sales/selladmin/salesOrderDetails?id='+record.orderId+'&type='+type)
            }
        },
    },

}
</script>
<style scoped lang="scss">
.page-container-height{
    background: #ffffff;
    .order-top{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 80px;
        padding:0 30px;
        .order-top-left{
            display: flex;
            align-items: center;
            .market-input{
                width: 200px;
                margin: 0 20px;
            }

        }
        .order-top-right{
            width: 100px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fafafa;
            border: 1px solid #ebebeb;
            border-radius: 6px;
            color: var(--co);
            img{
                width: 15px;
                margin-right: 5px;
            }
        }
    }
     .market-tab{
        padding: 10px 30px;
        display: flex;
        align-items: center;
        .market-tab-item{
            color: #919191;
            font-size: 16px;
            img{
                width: 32px;
                height: 32px;
                margin-right: 10px;
            }
        }
        .market-tab-item-active{
            color: #387bfc;
        }
        .market-tab-line{
            width: 2px;
            height: 18px;
            background: #919191;
            margin: 0 30px;
        } 
        
    }
    .operation-title{
        color: #387bfc;
    }
    .state-title{
        color: #aaa;
        font-size: 14px;
        display: flex;
        align-items: center;
        .state-cire-order{
            display: inline-block;
            width: 4px;
            height: 4px;
            background: #aaa;
            border-radius: 50%;
            margin-right: 5px;
        }
    }
    .state-titile1{
        color: #35ad00;
        .state-cire-order{
            background: #35ad00;
        }
    }
    .state-titile2{
        color: #f76f14;
        .state-cire-order{
            background: #f76f14;
        }
    }
}
</style>
